import _ from 'lodash'
import camelCaseKeys from 'utils/camelCase'
import log from 'blazar-sentry'

export const getJsonContent = (response) =>
  response.json().then((content) => {
    const camelCased = camelCaseKeys(content, { deep: true })
    camelCased._raw = content
    return camelCased
  })

// Throw errors depending on problem for logging and debugging purposes
// Maybe for routing purposes in the future? Like routing to an error page
// if we can't communicate with the API at all?
// Made to be run in a promise chain for isomorphic fetch so return argument by default
export default (response) => {
  const contentType = response.headers.get('Content-Type')
  let parseMethod = null

  if (_.includes(contentType, 'json')) {
    parseMethod = 'json'
  }

  if (_.includes(contentType, 'text')) {
    parseMethod = 'text'
  }

  // Always parse the response to text or json, this is not ideal since this
  // action is "destructive". We do this because some endpoints return
  // status 200 with json { status: 'ERROR' }
  return Promise.resolve()
    .then(() => {
      if (response.status === 204) {
        return ''
      }

      switch (parseMethod) {
        case 'text':
          return response.text()
        case 'json':
          return getJsonContent(response)
        default:
          return ''
      }
    })
    .then((textOrJson) => {
      if (
        !response.ok ||
        (parseMethod === 'json' && textOrJson.status === 'ERROR') ||
        (parseMethod === 'json' && _.get(textOrJson, 'apiError.status') === 'TRANS_ERROR')
      ) {
        const error = new Error('Api call failed with non 2xx status code')
        error.status = response.status || 500
        error.ok = false
        error.url = response.url
        error.textOrJson = textOrJson

        log.warn(error)

        return error
      }

      return {
        ..._.pick(response, ['status', 'statusText', 'ok', 'type']),
        textOrJson,
      }
    })
    .catch((e) => log.error(e))
}
